export default __webpack_public_path__ + "static/media/square.5bce03cb.svg";